export default __webpack_public_path__ + "static/media/mediumLogoWhite.fa0ebef9.svg";